module.exports = __webpack_public_path__ + "img/fig1.27176b77.png";